import React from 'react'
import { CloseCircleOutlined } from '@ant-design/icons'
import { message } from 'antd'
import { POST_MEDIA_FILTER } from 'src/configs'

interface MultipleImageUploaderProps {
  images: any[]
  setImages: React.Dispatch<React.SetStateAction<any[]>>
  onRemoveImage: (index: number) => void
  uploadId: string
  maxImages?: number // Maximum number of images allowed, defaults to 6
}

const MultipleUpload: React.FC<MultipleImageUploaderProps> = ({
  images,
  setImages,
  onRemoveImage,
  uploadId,
  maxImages = 6, // Default to 6 for backward compatibility
}) => {
  const handleChangeMultipleMedia = (e: any) => {
    if (!e.target.files || e.target.files.length === 0) return

    if (e.target.files.length + images.length > maxImages) {
      message.error(`You can only upload ${maxImages} files`)
      return
    }

    const localImages: any = []
    const allowedInputType = ['mp4', 'mpeg', 'jpg', 'jpeg', 'png', 'gif']
      .join('/')
      .toUpperCase()

    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i]
      const isValidSize = Number(file.size) / 1024 / 1024 < 10
      const isValidType = POST_MEDIA_FILTER.test(file.type)

      if (!isValidType) {
        message.error(`You can only upload ${allowedInputType} file!`)
        break
      }

      if (!isValidSize) {
        message.error('Media file must be smaller than 10MB!')
        break
      }

      localImages.push({ file, src: URL.createObjectURL(file) })
    }

    setImages((prev: any) => [...prev, ...localImages])
  }

  return (
    <div className="mt-[16px]">
      {!!images?.length && (
        <div className="flex items-center justify-start gap-[16px] flex-wrap mb-[12px]">
          {images?.map((image, index) => (
            <div className="border rounded-[8px] relative" key={index}>
              <div
                className="flex items-center justify-center absolute right-[-10px] top-[-10px] cursor-pointer z-10 bg-white rounded-full"
                onClick={() => {
                  onRemoveImage(index)
                }}
              >
                <CloseCircleOutlined className="text-[20px]" />
              </div>
              <img
                src={image.src}
                alt={`Event gallery ${index + 1}`}
                className="w-[200px] h-[200px] object-contain rounded-[8px]"
              />
            </div>
          ))}
        </div>
      )}
      <label
        className={`bg-main border-main text-white rounded-[6px] text-[14px] font-medium py-[8px] px-[12px] min-w-[96px] inline-block h-fit cursor-pointer hover:opacity-80 transition-all duration-300 text-center ${
          images.length >= maxImages ? 'opacity-80' : 'opacity-100'
        }`}
        htmlFor={uploadId}
      >
        Upload
      </label>
      <input
        type="file"
        className="hidden"
        id={uploadId}
        multiple={true}
        disabled={images.length >= maxImages}
        onChange={handleChangeMultipleMedia}
      />
    </div>
  )
}

export default MultipleUpload
